export default __webpack_public_path__ + "static/media/Nggoth.dfeab51a.jpg";